module.exports = __webpack_public_path__ + "img/bathroom.5fca77d0.jpg";